import {
    Autocomplete,
    Avatar,
    Box,
    Chip,
    CircularProgress,
    ListItem,
    ListItemText,
    TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";

import debounce from "lodash.debounce"; // npm install lodash.debounce

import { Store } from "@mui/icons-material";

const ControlledAutocomplete = ({ name, label, fetchOptions, form, rules }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const { control, setValue, watch } = form;
    const selectedValue = watch(name);
    useEffect(() => {
        const key = `${name}_id`;
        if (selectedValue) {
            setValue(key, selectedValue.id);
        }
    }, [name, selectedValue, setValue]);

    // Debounced fetch
    const debouncedFetch = debounce(async (query) => {
        console.log(query);
        setLoading(true);
        try {
            const res = await fetchOptions(10, 1, { name: query });
            setOptions(res.results); // assumes response is an array of { id, name }
        } catch (err) {
            console.error("Failed to fetch sellers", err);
            setOptions([]);
        }
        setLoading(false);
    }, 500); // wait 500ms after typing

    // useEffect(() => {
    // 	// Initial fetch
    // 	fetchSellers("");
    // }, []);

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={""}
            render={({ field, fieldState }) => (
                <Autocomplete
                    freeSolo
                    {...field}
                    options={options}
                    loading={loading}
                    getOptionLabel={(option) => option?.name || ""}
                    isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                    }
                    onInputChange={(e, input) => {
                        if (input?.length > 0) {debouncedFetch(input);}
                    }}
                    renderOption={(props, option) => (
                        <ListItem {...props} key={option.id}>
                            {"colorCode" in option ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                    }}
                                >
                                    <Chip
                                        // label={size}
                                        variant="outlined"
                                        // color={option.colorCode}
                                        sx={{
                                            bgcolor: option.colorCode,
                                            width: 30,
                                            height: 30,
                                            borderRadius: "50%",
                                        }}
                                    />

                                    <ListItemText primary={option.name} />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                    }}
                                >
                                    <Avatar
                                        src={
                                            option.logo
                                                ? option.logo.file
                                                : null
                                        }
                                        alt={option.name}
                                        sx={{
                                            width: 30,
                                            height: 30,
                                            bgcolor: "#003B6D",
                                            // border: "2px solid #ccc",
                                        }}
                                    >
                                        <Store fontSize="small" />
                                    </Avatar>
                                    <ListItemText primary={option.name} />
                                </Box>
                            )}
                        </ListItem>
                    )}
                    onChange={(e, newValue) => field.onChange(newValue)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            inputRef={field.ref}
                            error={!!fieldState.error} // ✅ shows red border on error
                            helperText={fieldState.error?.message} // ✅ shows error message
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading && (
                                            <CircularProgress
                                                color="inherit"
                                                size={20}
                                            />
                                        )}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            )}
        />
    );
};

export default ControlledAutocomplete;
